import React, {Fragment} from "react";
import Login from "./Auth/Login";
import {
    Switch,
    Route,
} from "react-router-dom";
import ForgotPassword from "./Auth/ForgotPassword";
import Home from "./Pages/Home";
import Users from "./Pages/Users";
import Outlets from "./Pages/Outlets";
import Firebase from "../Firebase";
import {useListVals} from "react-firebase-hooks/database";
import Products from "./Pages/Products/Products";
import ProductsViewPage from "./Pages/Products/ProductsViewPage";
import Tasks from "./Pages/Tasks";
import Logs from "./Pages/Logs";
import Settings from "./Pages/Settings";
import ViewOneProduct from "./Pages/Products/ViewOneProduct";
import Sales from "./Pages/Sales";

//const outletRef = Firebase.database().ref('System/Outlets');
const userRef = Firebase.database().ref('System/Users');
const Navigation = () => {

    const [users] = useListVals(userRef);
    //const [outlets] = useListVals(outletRef);
    return (
        <Fragment>
            <Switch>

                <Route path="/" render={(props) => (
                    <Login {...props} />)} exact />

                <Route path="/login" render={(props) => (
                    <Login {...props} />)} exact />

                <Route path="/forgot" render={(props) => (
                    <ForgotPassword {...props} />)} exact />

                <Route path="/home" render={(props) => (
                    <Home {...props} />)} exact />

                <Route path="/users" render={(props) => (
                    <Users {...props} />)} exact />

                <Route path="/outlets" render={(props) => (
                    <Outlets users={users} {...props} />)} exact />

                <Route path="/products" render={(props) => (
                    <ProductsViewPage {...props} />)} exact />

                <Route path="/products/:id" render={(props) => (
                    <ViewOneProduct {...props} />)} exact />

                <Route path="/outletProducts" render={(props) => (
                    <Products {...props} />)} exact />

                <Route path="/tasks" render={(props) => (
                    <Tasks {...props} />)} exact />

                <Route path="/logs" render={(props) => (
                    <Logs {...props} />)} exact />

                <Route path="/settings" render={(props) => (
                    <Settings {...props} />)} exact />



                <Route path="/sales" render={(props) => (
                    <Sales {...props} />)} exact />

            </Switch>
        </Fragment>
    );

}

export default Navigation;
